module.exports = __webpack_public_path__ + "img/Gerettete_Person.40838dd3.svg";